<div class="dashboard" [@fadeInUp]>
  <!-- Breadcrumb -->
  <nav class="breadcrumb">
    <mat-icon>home</mat-icon>
    <span class="breadcrumb-separator">/</span>
    <span class="breadcrumb-current">Dashboard</span>
  </nav>

  <!-- Dashboard Header -->
  <div class="dashboard-header">
    <div>
      <h1>Dashboard</h1>
      <p class="subtitle">Welcome to Equidesk Admin Panel</p>
    </div>
  </div>

  <!-- Stats Grid with Animated Counters -->
  <div class="stats-grid" [@listStagger]="recentTenants.length">
    <!-- Total Tenants Card -->
    <mat-card class="stat-card stat-card-primary">
      <mat-card-content>
        <div class="stat-content">
          <div class="stat-icon-wrapper stat-icon-primary">
            <mat-icon class="stat-icon">business</mat-icon>
          </div>
          <div class="stat-details">
            <h2 class="stat-number">{{ displayTotalTenants }}</h2>
            <p class="stat-label">Total Tenants</p>
            <div class="stat-trend">
              <mat-icon class="trend-icon positive">trending_up</mat-icon>
              <span class="trend-text">All organizations</span>
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>

    <!-- Total Modules Card -->
    <mat-card class="stat-card stat-card-success">
      <mat-card-content>
        <div class="stat-content">
          <div class="stat-icon-wrapper stat-icon-success">
            <mat-icon class="stat-icon">apps</mat-icon>
          </div>
          <div class="stat-details">
            <h2 class="stat-number">{{ displayTotalModules }}</h2>
            <p class="stat-label">Total Modules</p>
            <div class="stat-trend">
              <mat-icon class="trend-icon">extension</mat-icon>
              <span class="trend-text">Available features</span>
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>

    <!-- Active Tenants Card -->
    <mat-card class="stat-card stat-card-info">
      <mat-card-content>
        <div class="stat-content">
          <div class="stat-icon-wrapper stat-icon-info">
            <mat-icon class="stat-icon">check_circle</mat-icon>
          </div>
          <div class="stat-details">
            <h2 class="stat-number">{{ displayActiveTenants }}</h2>
            <p class="stat-label">Active Tenants</p>
            <div class="stat-trend">
              <mat-icon class="trend-icon positive">trending_up</mat-icon>
              <span class="trend-text">Currently active</span>
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>

    <!-- Core Modules Card -->
    <mat-card class="stat-card stat-card-warning">
      <mat-card-content>
        <div class="stat-content">
          <div class="stat-icon-wrapper stat-icon-warning">
            <mat-icon class="stat-icon">star</mat-icon>
          </div>
          <div class="stat-details">
            <h2 class="stat-number">{{ displayCoreModules }}</h2>
            <p class="stat-label">Core Modules</p>
            <div class="stat-trend">
              <mat-icon class="trend-icon">workspace_premium</mat-icon>
              <span class="trend-text">Essential features</span>
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>

  <!-- Recent Activity Section -->
  <div class="activity-grid">
    <!-- Recent Tenants -->
    <mat-card class="activity-card">
      <mat-card-header>
        <mat-card-title>
          <mat-icon>business</mat-icon>
          Recent Tenants
        </mat-card-title>
        <button mat-button color="primary" routerLink="/tenants" class="view-all-btn">
          View All
          <mat-icon>arrow_forward</mat-icon>
        </button>
      </mat-card-header>
      <mat-card-content>
        @if (isLoadingTenants) {
          <div class="loading-container">
            <mat-spinner diameter="40"></mat-spinner>
            <p>Loading tenants...</p>
          </div>
        } @else if (recentTenants.length > 0) {
          <div class="activity-list">
            @for (tenant of recentTenants; track tenant.id) {
              <div class="activity-item">
                <div class="activity-avatar tenant-avatar">
                  {{ tenant.name.substring(0, 2).toUpperCase() }}
                </div>
                <div class="activity-content">
                  <h4 class="activity-title">{{ tenant.name }}</h4>
                  <p class="activity-subtitle">{{ tenant.slug }}</p>
                </div>
                <span [class]="'status-badge ' + getStatusBadgeClass(tenant.isActive)">
                  {{ tenant.isActive ? 'Active' : 'Inactive' }}
                </span>
              </div>
            }
          </div>
        } @else {
          <div class="empty-state-small">
            <mat-icon>info</mat-icon>
            <p>No tenants yet</p>
          </div>
        }
      </mat-card-content>
    </mat-card>

    <!-- Recent Modules -->
    <mat-card class="activity-card">
      <mat-card-header>
        <mat-card-title>
          <mat-icon>apps</mat-icon>
          Recent Modules
        </mat-card-title>
        <button mat-button color="primary" routerLink="/modules" class="view-all-btn">
          View All
          <mat-icon>arrow_forward</mat-icon>
        </button>
      </mat-card-header>
      <mat-card-content>
        @if (isLoadingModules) {
          <div class="loading-container">
            <mat-spinner diameter="40"></mat-spinner>
            <p>Loading modules...</p>
          </div>
        } @else if (recentModules.length > 0) {
          <div class="activity-list">
            @for (module of recentModules; track module.id) {
              <div class="activity-item">
                <div mat-card-avatar class="module-avatar" [class]="getModuleTypeClass(module.type)" [style.background]="module.color || null">
                  <mat-icon>{{ module.icon || 'apps' }}</mat-icon>
                </div>
                <div class="activity-content">
                  <h4 class="activity-title">{{ module.name }}</h4>
                  <p class="activity-subtitle">{{ module.type || 'Other' }}</p>
                </div>
                <span [class]="'status-badge status-badge-' + module.status">
                  {{ module.status }}
                </span>
              </div>
            }
          </div>
        } @else {
          <div class="empty-state-small">
            <mat-icon>info</mat-icon>
            <p>No modules yet</p>
          </div>
        }
      </mat-card-content>
    </mat-card>
  </div>
</div>
